export default __webpack_public_path__ + "static/media/drink2.55092f03.jpg";